export default "__VITE_ASSET__6edd5236__"